
import { HttpParams } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, EventEmitter, Inject, Input, OnInit, Output, inject, DestroyRef ,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActionService } from '../../../shared/_services/action.service';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import { environment } from '../../../../environments/environment';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
interface Category {
  CATEGORY: string;
  CBC_ID: string;
  ID: string;
  PIVOT_MAP: string;
  S3_CLIENT_KEY?: number | string | null;
}
interface GtwInput {
  baseUrl: string;
  ssoId: string;
  clientKey: number;
  type: 'add' | 'delete'
  data: Category;
}
@Component({
    selector: 'gtw-cbc-beps-categories',
    templateUrl: './beps-categories.component.html',
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class BepsCategoriesComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);


  @Input('gtw-input')
  set gtwInputStr(input: string) {
    try {
      this.gtwInput = safeJsonInput<any>(input, null, 'beps-categories.parse1');
    } catch (e) {
      console.error('Error parsing gtwInput', e);
    }
  };

  gtwInput!: GtwInput;

  categoriesForm!: UntypedFormGroup;

  @Output('close-modal')
  closeModal = new EventEmitter();
  @Output('request-grid-update')
  requestGridUpdate = new EventEmitter<string>();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private actionService: ActionService,
    private alertService: GtwSnackbarService,
    private workspaceService: WorkspaceService,
    private appService: AppService
  ) { }

  ngOnInit(): void {
    this.categoriesForm = this.formBuilder.group({
      category: ['', Validators.required],
      cbc_id: ['', Validators.required]
    });
  }

  get isAddModal(): boolean {
    const modalName = this.workspaceService.workspaceFactory?.activeScreen?.data?.modalName
      || this.workspaceService.workspaceFactory?.activeScreen?.data?.modal_name;
    return modalName !== 'deleteBepsCategory';
  }

  private get selectedRow(): Category {
    const activeData = this.workspaceService.workspaceFactory?.activeScreen?.data || {};
    const gridData = activeData.gridData;
    return activeData.rowData
      || (Array.isArray(gridData) ? (gridData[0]?.data || gridData[0]) : null)
      || {} as Category;
  }

  private get clientKey(): number {
    const rawClientKey = this.selectedRow?.S3_CLIENT_KEY ?? this.appService.USER_SETTINGS?.user?.client_key ?? 0;
    return Number(rawClientKey) || 0;
  }

  onSubmit(): void {
    if (this.categoriesForm.valid) {
      const params = new HttpParams({
        fromObject: this.categoriesForm.value
      });
      this.actionService.saveActionData(environment.base_url, 33281, this.clientKey, params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: any) => {

        if (response.callSuccess === "1") {
          this.alertService.openSnackBar("Data saved successfully", "gtw-snackbar--green");
          this.refresh();
        } else {
          this.alertService.openSnackBar("Failed to save data", "gtw-snackbar--red");
          this.cancel();
        }
      });
    }
  }

  delete() {
    const row = this.selectedRow;

    const params = new HttpParams({
      fromObject: {
        id: row.ID
      }
    });
    this.actionService.saveActionData(environment.base_url, 33282, this.clientKey, params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: any) => {

      if (response.callSuccess === "1") {
        this.alertService.openSnackBar("Data deleted successfully", "gtw-snackbar--green");
        this.refresh();
      } else {
        this.alertService.openSnackBar("Failed to delete data", "gtw-snackbar--red");
        this.cancel();
      }
    });
  }

  cancel() {
    this.closeModal.emit();
  }

  private refresh() {
    this.requestGridUpdate.emit('refresh');
  }
}
